<template>
    <div>
      <modal name="error-modal" :width="400" :height="'auto'" :clickToClose="false">
        <div class="modal-content">
          <span class="closebtn" @click="closeError">&times;</span>
          <i class="fas fa-exclamation-circle fa-5x" style="color: #ffffff; size: 5rem;"></i>
        </div>
        <div class="text-center p-3 mb-3">
            <strong style="font-size: 30px; color: #f44336ea;">Error!</strong> 
            <h6 class="mt-2">{{ errorMessage }}</h6>
        </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    props: {
        errorMessage: String
    },
    data() {
      return {
        
      };
    },
    methods: {
      closeError() {
        this.$modal.hide('error-modal');
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-content {
    padding: 15px;
    background-color: #f44336ea; /* Red */
    color: white;
    border-top-left-radius: 15px; /* Rounded top-left corner */
    border-top-right-radius: 15px; /* Rounded top-right corner */
    position: relative; /* For positioning the close button */
    text-align: center; /* Center the text */
  }
  
  .closebtn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: white;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: rgb(214, 212, 212);
  }
  </style>
  